import React from 'react';
import ReactDom from 'react-dom';
import DemoApp from "./demo";

ReactDom.render(<DemoApp/>, document.getElementById('root'));